import { useEffect } from 'react';
import { getUnlockedAudioContext, installAudioUnlockListener } from '../Chatengine/context/ShareAudio';

const NotificationSound = ({ sounds = [], onSoundComplete }) => {
  const currentSound = sounds[0];

  useEffect(() => installAudioUnlockListener(), []);

  useEffect(() => {
    let source;
    let isActive = true;

    if (currentSound?.audioSrc) {
      const audioContext = getUnlockedAudioContext();
      if (!audioContext) {
        onSoundComplete?.(currentSound.id);
        return undefined;
      }
      fetch(currentSound.audioSrc)
        .then((res) => res.arrayBuffer())
        .then((buf) => audioContext.decodeAudioData(buf))
        .then((decoded) => {
          if (!isActive) return;
          source = audioContext.createBufferSource();
          source.buffer = decoded;
          source.connect(audioContext.destination);
          source.onended = () => onSoundComplete?.(currentSound.id);
          source.start(0);
        })
        .catch((err) => {
          console.error('Audio error:', err);
          onSoundComplete?.(currentSound.id);
        });
    }

    return () => {
      isActive = false;
      if (source) {
        try { source.stop(); } catch (_) { }
        source.disconnect();
      }
    };
  }, [currentSound, onSoundComplete]);

  return currentSound?.message ? (
    <div className="notification">
      <p>{currentSound.message}</p>
    </div>
  ) : null;
};

export default NotificationSound;
